import React, { Component } from 'react';
import { Helmet } from 'react-helmet'
import Breadcrumb from "../common/breadcrumb";
import NewProduct from "../common/new-product";
import Filter from "./common/filter";
import FilterBar from "./common/filter-bar";
import ProductListing from "./common/product-listing";
import ProductLists from "./common/product-lists";
import StickyBox from "react-sticky-box";
import Paystar from "../../assets/icon/paystar.svg"

class CollectionLeftSidebar extends Component {

    state = {
        layoutColumns: 3,
        quantity: 1,
        stock: 'InStock',

    }
    minusQty = () => {
        if (this.state.quantity > 1) {
            // this.setState({ stock: 'InStock' })
            this.setState({ quantity: this.state.quantity - 1 })
        }
    }

    plusQty = () => {
        // if (this.props.item.stock >= this.state.quantity) {
        this.setState({ quantity: this.state.quantity + 1 })
        // } else {
        // this.setState({ stock: 'Out of Stock !' })
        // }
    }
    changeQty = (e) => {
        this.setState({ quantity: parseInt(e.target.value) })
    }
    LayoutViewClicked(colums) {
        this.setState({
            layoutColumns: colums
        })
    }

    openFilter = () => {
        document.querySelector(".collection-filter").style = "left: -15px";
    }

    render() {
        return (
            <div>
                {/*SEO Support*/}
                <Helmet>
                    <title>MultiKart | Collection of Products</title>
                    <meta name="description" content="Multikart – Multipurpose eCommerce React Template is a multi-use React template. It is designed to go well with multi-purpose websites. Multikart Bootstrap 4 Template will help you run multiple businesses." />
                </Helmet>
                {/*SEO Support End */}

                <Breadcrumb title={'Collection'} />

                <section className="section-b-space">
                    <div className="collection-wrapper">
                        <div className="container">
                            <div className="row">
                                <div className="col-sm-3 collection-filter">

                                    <StickyBox offsetTop={20} offsetBottom={20}>
                                        <div>
                                            <Filter />
                                            <NewProduct />
                                            {/* <div className="collection-sidebar-banner">
                                                <a href="#">
                                                    <img src={`${process.env.PUBLIC_URL}/assets/images/side-banner.png`} className="img-fluid" alt="" />
                                                </a>
                                            </div> */}
                                        </div>
                                    </StickyBox>
                                    {/*side-bar banner end here*/}
                                </div>
                                <div className="collection-content col">
                                    <div className="page-main-content ">
                                        <div className="">
                                            <div className="row">
                                                <div className="col-sm-12">
                                                    {/* <div className="top-banner-wrapper">
                                                        <a href="#"><img src={`${process.env.PUBLIC_URL}/assets/images/mega-menu/2.jpg`} className="img-fluid" alt=""/></a>
                                                        <div className="top-banner-content small-section">
                                                            <h4>fashion</h4>
                                                            <h5>Lorem Ipsum is simply dummy text of the printing and typesetting industry.</h5>
                                                            <p>Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum. </p>
                                                        </div>
                                                    </div> */}
                                                    <div className="collection-product-wrapper">
                                                        <div className="product-top-filter">
                                                            <div className="container-fluid p-0">
                                                                <div className="row">
                                                                    <div className="col-xl-12">
                                                                        <div className="filter-main-btn">
                                                                            <span onClick={this.openFilter}
                                                                                className="filter-btn btn btn-theme"><i
                                                                                    className="fa fa-filter"
                                                                                    aria-hidden="true"></i> Filter</span>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                {/* <div className="row">
                                                                    <div className="col-12">
                                                                        <FilterBar onLayoutViewClicked={(colmuns) => this.LayoutViewClicked(colmuns)} />
                                                                    </div>
                                                                </div> */}
                                                            </div>
                                                        </div>

                                                        <div className='first-section-item-box mt-3'>
                                                            <div className='d-flex' style={{ alignItems: 'center', justifyContent: 'start', gap: '5px' }}>
                                                                <span className='step'>مرحله اول</span>
                                                                <span>گیفت کارت ها</span>
                                                            </div>
                                                            <ProductListing colSize={this.state.layoutColumns} />

                                                        </div>
                                                        <hr className='mt-5' />
                                                        <div className='first-section-item-box mt-3'>
                                                            <div className='d-flex' style={{ alignItems: 'center', justifyContent: 'start', gap: '5px' }}>
                                                                <span className='step'>مرحله دوم</span>
                                                                <span>تسویه حساب و خرید گیفت کارت</span>
                                                            </div>
                                                            <div className="row" style={{ gap: '1rem' }}>

                                                                <div className='col-md-7 col-sm-12 col-lg-7 tree-section p-3'> <div className=''>
                                                                    <h4 className='text-center'>گیفت کارت اپل ایتونز ایتالیا</h4>
                                                                </div>
                                                                    <div className='display-flex mt-4'>
                                                                        <h6 className='text-center'>تعداد :</h6>
                                                                        <div className="qty-box">
                                                                            <div className="input-group">
                                                                                <span className="input-group-prepend">
                                                                                    <button type="button" className="btn quantity-left-minus" onClick={this.minusQty} data-type="minus" data-field="">
                                                                                        <i className="fa fa-minus" style={{ color: 'red' }}></i>
                                                                                    </button>
                                                                                </span>
                                                                                <input type="text" name="quantity" value={this.state.quantity} onChange={this.changeQty} className="form-control input-number" />
                                                                                <span className="input-group-prepend">
                                                                                    <button type="button" className="btn quantity-right-plus" onClick={this.plusQty} data-type="plus" data-field="">
                                                                                        <i className="fa fa-plus" style={{ color: 'green' }}></i>
                                                                                    </button>
                                                                                </span>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                    <hr />
                                                                    <div className='display-flex mt-4'>
                                                                        <h6 className='text-center'>قیمت واحد :</h6>
                                                                        <h6>20000 تومان</h6>
                                                                    </div>
                                                                    <hr />
                                                                    <div className='display-flex mt-4'>
                                                                        <h6 className='text-center'>قیمت نهایی :</h6>
                                                                        <h5 style={{color:'red'}}>500000 تومان</h5>
                                                                    </div>
                                                                    <hr />
                                                                 

                                                                            <div className='text-center'>
                                                                                <div className='pay-img mt-5'>
                                                                                    <img src={Paystar} alt="" />
                                                                                    <img src={Paystar} alt="" />
                                                                                </div>
                                                                                <button className='btn btn-primary w-50 mt-2' >پرداخت</button>
                                                                            </div>



                                                                </div>
                                                                <div className='col-md-4 col-sm-12 col-lg-4 tree-section text-center'>


                                                                    <span>   <i className="fa fa-info-circle" style={{ color: '#b5b5b5' }}></i> توضیحات سرویس</span>
                                                                    <p className='text-center mt-5' style={{ lineHeight: '25px' }}>محصولات اپل برای دسترسی به خدمات، امکانات و برنامه‌های این کمپانی باید از فروشگاه‌هایی تحت عنوان اپ استور (App Store) یا آیتونز (iTunes) استفاده کنند. در این بین دسترسی به بسیاری از خدمات و برنامه‌های موجود در آن نیازمند پرداخت مبلغی پول است. گیفت کارت اپل راهی برای شارژ کردن حساب کاربری شما در این فروشگاه‌ها و استفاده از خدمات غیررایگان آن‌ها است.</p>
                                                                </div>
                                                            </div>


                                                        </div>

                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>

            </div>
        )
    }
}

export default CollectionLeftSidebar;